import { object } from 'yup';

const schema = object({});

export default schema;
